import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminUsersRoutes: RouteObject[] = [
  {
    path: 'admin/users',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_USERS, title: 'Utilisateurs' },
  },
  {
    path: 'admin/users/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_USER_FORM, title: 'Nouvel utilisateur' },
  },
  {
    path: 'admin/users/:userId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_USER_FORM, title: "Modifier l'utilisateur" },
  },
];
